import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/node/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/node/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Util } from './Util.js';
import { Container } from './Container.js';
import { _registerNode } from './Global.js';
export var Group = /*#__PURE__*/function (_Container) {
  _inherits(Group, _Container);
  var _super = _createSuper(Group);
  function Group() {
    _classCallCheck(this, Group);
    return _super.apply(this, arguments);
  }
  _createClass(Group, [{
    key: "_validateAdd",
    value: function _validateAdd(child) {
      var type = child.getType();
      if (type !== 'Group' && type !== 'Shape') {
        Util.throw('You may only add groups and shapes to groups.');
      }
    }
  }]);
  return Group;
}(Container);
Group.prototype.nodeType = 'Group';
_registerNode(Group);